/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_License_StatusInputs */

const cs_office_license_status = /** @type {(inputs: Office_License_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav licence`)
};

const en_office_license_status = /** @type {(inputs: Office_License_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License status`)
};

/**
* | output |
* | --- |
* | "License status" |
*
* @param {Office_License_StatusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const office_license_status = /** @type {((inputs?: Office_License_StatusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_License_StatusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_license_status(inputs)
	return cs_office_license_status(inputs)
});